export const iconFontAwesomeEditingMinus = (
	<i className="fa-solid fa-minus"></i>
);
